export default "__VITE_PUBLIC_ASSET__6030d3bb__"